import React from 'react';
import * as Ui from "./styles";

const OUTLINED = "outlined";
const FILLED = "filled";

export const evolutiveCrossButtonStyles = {
  [OUTLINED]: OUTLINED,
  [FILLED]: FILLED,
};

const evolutiveButtons = {
  [OUTLINED]: Ui.OutlinedButton,
  [FILLED]: Ui.FilledButton,
};

export function EvolutiveCrossButton({ fillStyle = FILLED, ...props }) {
  const Button = evolutiveButtons[fillStyle];

  return <Button {...props} />;
}
